<template>
	<div class="gateway-entry payment-option-header layout-row " :class="{'round':currentGroup.id === 3}"
	     @click="gatewayClicked(userGateway)">

		<div class="left flex">
			<span class="name">{{userGateway.name}}</span>
			<b> ({{userGateway.gateway.name}})</b>
		</div>

		<!--	          if not COD allow edit/delete. -->
		<div class="right layout-row" v-if="currentGroup.id !== 3">
			<a @click.stop="$emit('editUserGateway', userGateway)" class="panel_item_btn copy_btn">
				<svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" data-icon="edit" data-prefix="fas" id="ember3436" class="svg-inline--fa fa-edit fa-w-18  undefined ember-view" style="width: 18px; height: 18px;">
					<path fill="currentColor" d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"></path>
				</svg>
			</a>
			<a @click.stop="deleteOpen=true" class="panel_item_btn delete_btn">
				<v-spinner v-if="deleting" />
				<inline-svg v-else :src="require('@/assets/img/delete_icon.svg')"/>
			</a>
		</div>

		<portal to="popup">
			<delete-gateway-popup :userGateway="userGateway" v-if="deleteOpen" @close="deleteOpen=false" @done="deleteGateway" />
		</portal>
	</div>
</template>

<script>
import API from "@/api";
import VSpinner from "@/components/base/v-spinner";
import DeleteGatewayPopup from "@/views/funnels/apps/funnel-apps/fpay/delete-gateway-popup";

export default {
	name: "gateway-entry",
	components: {DeleteGatewayPopup, VSpinner},
	props: ["currentGroup", "userGateway"],
	mixins: [API],
	data() {
		return {
			deleteOpen:false,
			deleting: false,
		}
	},
	methods: {
		gatewayClicked(userGateway) {
			this.$emit('gatewayClicked', userGateway)
		},
		async deleteGateway() {
			try {
				this.deleteOpen = false;
				this.deleting = true;
				await this.api.gateways.delete(this.userGateway.id)
				let index = this.currentGroup.user_gateways.indexOf(this.userGateway);
				if (index>=0) {
					this.currentGroup.user_gateways.splice(index, 1);
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.deleting = false;
			}
			this.$emit('deleteGateway', this.userGateway)
		},
	}
}
</script>

<style lang="scss" scoped>
.gateway-entry {
	.delete_btn {
		position: relative;
	}
}
</style>
